/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ApiMarcatoreMarcatoreDeleteDelete$Params {
    /**
     * Id del marcatore da eliminare
     */
    marcatoreId: number;
}

export function apiMarcatoreMarcatoreDeleteDelete(
    http: HttpClient,
    rootUrl: string,
    params: ApiMarcatoreMarcatoreDeleteDelete$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(rootUrl, apiMarcatoreMarcatoreDeleteDelete.PATH, 'delete');
    if (params) {
        rb.query('marcatoreId', params.marcatoreId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({
                body: String((r as HttpResponse<any>).body) === 'true',
            }) as StrictHttpResponse<boolean>;
        }),
    );
}

apiMarcatoreMarcatoreDeleteDelete.PATH = '/api/marcatore/marcatore-delete';
